import { cx } from './cx';

export type AvatarSize = 'sm' | 'md' | 'lg';

const sizeClasses: Record<AvatarSize, string> = {
  sm: 'size-7 text-xs',
  md: 'size-9 text-sm',
  lg: 'size-11 text-base',
};

function initials(name: string): string {
  const parts = name
    .trim()
    .split(/[\s/_-]+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export interface AvatarProps {
  name: string;
  src?: string;
  size?: AvatarSize;
  className?: string;
}

/**
 * Avatar — a user/owner image, or a brand-tinted initials fallback. Used in
 * tables and cards for owners, requesters and members.
 */
export const Avatar = ({ name, src, size = 'md', className }: AvatarProps) => {
  const base = cx(
    'inline-flex shrink-0 items-center justify-center rounded-full',
    sizeClasses[size],
    className,
  );
  if (src) {
    return <img src={src} alt={name} className={cx(base, 'object-cover')} />;
  }
  return (
    <span
      className={cx(base, 'bg-brand-solid/12 font-semibold text-brand-text')}
      aria-hidden
    >
      {initials(name)}
    </span>
  );
};
